import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'

// Bootstrap 4 CSS
import 'bootstrap/dist/css/bootstrap.min.css'

// Custom styles (must come after Bootstrap)
import './assets/scss/style.scss'
import './assets/scss/style-utilities.scss'

// Bootstrap 4 JS (requires jQuery and Popper)
import 'jquery'
import 'popper.js'
import 'bootstrap/dist/js/bootstrap.min.js'
import { useTracer } from './composables/useTracer'

const app = createApp(App)

app.use(createPinia())
app.use(router)

const tracer = useTracer()
tracer
  .init()
  .then(() => {
    tracer.installRouterTracking(router)
  })
  .catch(() => {
    console.debug('[Tracer] Analytics not loaded')
  })

app.mount('#app')
